import {
  renderSectionHeader,
  renderMainLeftCell,
  renderMainRightCell,
  renderSoftLeftCell,
  renderColumnGaps,
  renderRowGaps
} from '../helpers';

export const renderFundFactsRow = fact => {
  let rowString = `<tr>`;
  const labelCell = fact.superScript ? `${fact.label} ${fact.superScript}` : fact.label;
  rowString += renderMainLeftCell(labelCell);
  rowString += renderMainRightCell(fact.data);
  rowString += renderColumnGaps();
  rowString += renderSoftLeftCell(fact.date);
  rowString += `</tr>`;
  return rowString;
};

export const fundFactsModule = data => {
  let fundFactString = ``;
  fundFactString += renderSectionHeader('Fund Facts');
  fundFactString += renderRowGaps();
  data.forEach(fact => {
    fundFactString += renderFundFactsRow(fact);
  });
  fundFactString += renderRowGaps();
  return fundFactString;
};
